const Menuitems = [
    {
        navlabel: true,
        subheader: "Repositório de Eitri Apps e Recursos",
        icon: "mdi mdi-dots-horizontal",
        href: "Eitri App"
    },
    {
        title: "Eitri Apps",
        icon: "package",
        href: "/eitri-app-management/eitri-apps"
    },
    {
        navlabel: true,
        subheader: "Controle de Membros",
        icon: "mdi mdi-dots-horizontal",
        href: "Eitri App"
    },
    {
        title: "Usuários",
        icon: "users",
        href: "/user-management",
        collapse: true,
        children: [
            {
                title: "Catálogo de Usuários",
                icon: "list",
                href: "/user-management/users"
            },
            {
                title: "Inserir Usuários",
                icon: "user-plus",
                href: "/user-management/create-user"
            }
        ]
    }
];

export default Menuitems;
